/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventTooltipsResident
 */
export interface IntegrationEventTooltipsResident {
    /**
     * 
     */
    message?: string;
}

/**
 * Check if a given object implements the IntegrationEventTooltipsResident interface.
 */
export function instanceOfIntegrationEventTooltipsResident(value: object): value is IntegrationEventTooltipsResident {
    return true;
}

export function IntegrationEventTooltipsResidentFromJSON(json: any): IntegrationEventTooltipsResident {
    return IntegrationEventTooltipsResidentFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsResidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltipsResident {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function IntegrationEventTooltipsResidentToJSON(json: any): IntegrationEventTooltipsResident {
    return IntegrationEventTooltipsResidentToJSONTyped(json, false);
}

export function IntegrationEventTooltipsResidentToJSONTyped(value?: IntegrationEventTooltipsResident | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

